import SharedProcessingTimeSection from "@/components/feature/SharedProcessingTimeSection";
import type { ProcessingOption } from "@/components/feature/SharedProcessingTimeSection";

const options: ProcessingOption[] = [
  {
    speed: "2–9",
    unit: "Business Days",
    label: "Fast Passport Center",
    tag: "Most Popular",
    tagColor: "bg-[#F6C344] text-[#1A365D]",
    features: [
      "Registered U.S. Department of State Courier",
      "Reserved agency submission",
      "Predictable turnaround",
      "Ideal for upcoming trips",
      "Document review included",
      "Dedicated agent assigned to your case",
      "Daily status updates — never left guessing",
      "Not affected by government shutdowns",
    ],
    highlight: true,
  },
  {
    speed: "3–5",
    unit: "Weeks",
    label: "Fast Passport Center",
    tag: "Standard Expedited",
    tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
    features: [
      "Registered U.S. Department of State Courier",
      "Reserved agency submission",
      "Faster than self-service",
      "Good for planned travel",
      "Document review included",
      "Dedicated agent assigned to your case",
      "Daily status updates — never left guessing",
      "Not affected by government shutdowns",
    ],
    highlight: false,
    smartSaver: true,
  },
  {
    speed: "1–2",
    unit: "Months",
    label: "Self-Service (Post Office)",
    tag: "Slowest",
    tagColor: "bg-gray-100 text-gray-400",
    features: [
      "No courier access — standard mail only",
      "Workload & wait times shift with shutdowns and budget fights",
      "In-person clerk appointment required",
      "No document review — errors cause rejection",
      "No dedicated agent — you are on your own",
      "Updates only by physical mail letter",
      "No phone or email contact for your case",
      "Can't upgrade speed after submission",
      "Not suitable if travel is within 10 weeks",
    ],
    highlight: false,
    muted: true,
  },
  {
    speed: "24",
    unit: "Hours*",
    label: "Regional Agency Processing",
    tag: "Emergency Only",
    tagColor: "bg-gray-100 text-gray-500",
    features: [
      "Appointment required — no walk-ins allowed",
      "Life-or-death emergencies only",
      "Bereavement or medical crisis",
      "Expect to wait all day or return next day",
    ],
    highlight: false,
    emergency: true,
  },
];

const emergencyText =
  "Miami ~60 mi via I-95 — but the distance is deceptive. Florida has only ONE passport agency (Miami) serving 22M+ residents. Boynton Beach sits between the Intracoastal Waterway and the Atlantic — I-95 during season (Nov–April) can turn 60 miles into 3+ hours with snowbird traffic. During hurricane season (June–Nov), I-95 becomes gridlocked with millions evacuating. Boynton's large retirement community means a higher concentration of international travelers — expired passports discovered days before a Mediterranean cruise or European river tour create a 6M+ South Florida bottleneck at Miami's single agency. Bridge closures on Southern Boulevard and Ocean Avenue during severe weather can isolate Boynton Beach from I-95 entirely.";

const disclaimerText =
  "*Processing speed depends on eligibility and documentation. Not all applicants qualify for Regional Agency Processing.";

export default function BoyntonBeachProcessingTimeSection() {
  return (
    <SharedProcessingTimeSection
      cityName="Boynton Beach"
      introText="Boynton Beach travelers — snowbirds heading to Europe, retirees on Mediterranean cruises, and families on Caribbean getaways — have several options for getting a passport fast. Here's how they compare, and why most south Palm Beach County residents choose a registered U.S. Department of State courier for predictable, professional processing."
      options={options}
      emergencyDescription={emergencyText}
      disclaimerText={disclaimerText}
    />
  );
}